import React from 'react';
import PropTypes from 'prop-types';
import PortableText from '../PortableText';
import Title from '../Title/Title';

const components = {
  block: {
    sectionTitle: ({ children }) => <Title level={4}>{children}</Title>,
    menuItemTitle: ({ children }) => <Title level={5}>{children}</Title>,
  },
};

function PortableMenuText({ value }) {
  return <PortableText value={value} components={components} />;
}

PortableMenuText.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default PortableMenuText;
